const whereBuyConstants = {
  TRADE_STORE_GET_INITIAL_STATE_REQUEST: 'TRADE_STORE_GET_INITIAL_STATE_REQUEST',
  TRADE_STORE_GET_INITIAL_STATE_SUCCESS: 'TRADE_STORE_GET_INITIAL_STATE_SUCCESS',
  TRADE_STORE_GET_INITIAL_STATE_FAILURE: 'TRADE_STORE_GET_INITIAL_STATE_FAILURE',
  TRADE_STORE_FILTER_BY_TYPE:            'TRADE_STORE_FILTER_BY_TYPE',
};

export default whereBuyConstants;